import { Injectable } from "@angular/core";
import { SettoreDTO } from "@app/shared/dto/settoreDTO";
import { SettoreVO } from "@app/shared/vo/settoreVO";
import { MapperInterface } from "@app/shared/mapper/mapper-inteface";
import { StrutturaFascicoloDTO } from "../dto/struttura-fascicoloDTO";

@Injectable({
  providedIn: "root",
})
export class MapperSettoreStruttura
  implements MapperInterface<StrutturaFascicoloDTO, SettoreVO> {
  constructor() {}

  convertVoToDto(settoreVO: SettoreVO): StrutturaFascicoloDTO {
    if (settoreVO != null) {
      const strutturaDTO = new StrutturaFascicoloDTO();
      strutturaDTO.cmu = settoreVO.codice;
      strutturaDTO.nome = settoreVO.nome;
      console.log("return", strutturaDTO);
      return strutturaDTO || new StrutturaFascicoloDTO();
    }
    return null;
  }

  convertDtoToVo(strutturaDTO: StrutturaFascicoloDTO): SettoreVO {
    // console.log("[MapperSettore] SettoreDTO => SettoreVO", settoreDTO);
    const settoreVO = new SettoreVO();
    if (strutturaDTO != null) {
      settoreVO.nome = strutturaDTO.nome;
      settoreVO.codice = strutturaDTO.cmu;
    }
    // console.log("[MapperSettore] fine SettoreDTO => SettoreVO", settoreVO);
    return settoreVO || new SettoreVO();
  }

  convertListVoToDto(settoreVOList: SettoreVO[]): StrutturaFascicoloDTO[] {
    // console.log("[MapperDocumenti] documentoDTOList => documentoVOList");

    const settoreDTOList = new Array<StrutturaFascicoloDTO>();
    settoreVOList.forEach((vo) => {
      settoreDTOList.push(this.convertVoToDto(vo));
    });

    return settoreDTOList || new Array<StrutturaFascicoloDTO>();
  }

  convertListDtoToVo(settoreDTOList: StrutturaFascicoloDTO[]): SettoreVO[] {
    /* console.log("[MapperSettori] settoreDTOList => settoreDTOList");
        console.log("settoreDTOList", settoreDTOList); */
    const settoreVOList = new Array<SettoreVO>();
    settoreDTOList.forEach((dto) => {
      settoreVOList.push(this.convertDtoToVo(dto));
    });

    return settoreVOList || new Array<SettoreVO>();
  }
}
